import React from "react";
import { Upcoming } from "pages";

const UpcomingRoute = () => {
  return (
    <>
      <Upcoming />
    </>
  );
};

export default UpcomingRoute;
